module.exports = {"630224100":"巴燕镇","630224101":"群科镇","630224102":"牙什尕镇","630224103":"甘都镇","630224104":"扎巴镇","630224105":"昂思多镇","630224200":"雄先藏族乡","630224201":"初麻乡","630224202":"查甫藏族乡","630224203":"塔加藏族乡","630224204":"金源藏族乡","630224205":"二塘乡","630224206":"谢家滩乡","630224207":"德恒隆乡","630224208":"沙连堡乡","630224209":"阿什奴乡","630224210":"石大仓乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630224.json
// module id = 3130
// module chunks = 0